'use client';
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState, useEffect } from 'react';

const MobileSidebarContext = createContext(undefined);
const useMobileSidebar = () => {
    const context = useContext(MobileSidebarContext);
    if (context === undefined) {
        throw new Error('useMobileSidebar must be used within a MobileSidebarProvider');
    }
    return context;
};
const MobileSidebarProvider = ({ children, }) => {
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
    }, [isOpen]);
    return (jsx(MobileSidebarContext.Provider, { value: { isOpen, setIsOpen }, children: children }));
};

export { MobileSidebarProvider, useMobileSidebar };
//# sourceMappingURL=mobile-sidebar-provider.js.map
